import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { isLayoutField } from '@core-engine/schema/field-type-guards/is-layout-field.js'
import { buildFieldMap } from './build-field-map.js'
import { generateDefaultValue } from './generate-default-value.js'

export function buildDefaultValues(
  flatFields: SchemaField[],
  dataSource = 'initialData',
  sourceFields = flatFields,
  options: { slugFallbackValue?: string } = {}
): string {
  const fieldMap = buildFieldMap(sourceFields)
  return flatFields
    .filter((f) => !f.primaryKey && f.type !== 'tabs' && !isLayoutField(f.type))
    .flatMap((f) => {
      const defs = [generateDefaultValue(f, fieldMap, dataSource, options)]
      if (f.hasIcon) defs.push(`      ${f.name}Icon: ${dataSource}?.${f.name}Icon ?? ''`)
      return defs
    })
    .join(',\n')
}
